import { render, staticRenderFns } from "./workInfo.vue?vue&type=template&id=7bbbe096&"
import script from "./workInfo.vue?vue&type=script&lang=js&"
export * from "./workInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports